import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { insights } from "../data/insights";
import { InsightCard } from "../components/InsightCard";
import { PageHead } from "../components/PageHead";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../lib/useTitle";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "Guide", label: "Guides" },
  { id: "Insight", label: "Insights" },
  { id: "News", label: "News" },
];

export default function Insights() {
  useTitle("Insights | Amplified Minds");
  const [filter, setFilter] = useState("all");
  const reduce = useReducedMotion();
  const visible = insights.filter((i) => filter === "all" || i.type === filter);

  return (
    <>
      <PageHead
        crumbs={[{ label: "Home", to: "/" }, { label: "Insights" }]}
        title="Insights and guides"
        lede="Practical guides, regulatory updates and news on setting up and running a business in India, the Middle East and Africa."
      >
        <div className="mt-7 flex flex-wrap gap-2" role="tablist" aria-label="Filter insights">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              type="button"
              role="tab"
              aria-selected={filter === f.id}
              data-testid={`insight-filter-${f.id.toLowerCase()}`}
              onClick={() => setFilter(f.id)}
              className="rounded-full border px-5 py-2 text-sm font-medium transition-colors duration-200"
              style={
                filter === f.id
                  ? { background: "var(--ink)", borderColor: "var(--ink)", color: "var(--on-accent)" }
                  : { background: "var(--surface)", borderColor: "var(--line)", color: "var(--muted)" }
              }
            >
              {f.label}
            </button>
          ))}
        </div>
      </PageHead>

      <section className="py-16 md:py-24">
        <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-8">
          <motion.div layout className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            <AnimatePresence mode="popLayout">
              {visible.map((item) => (
                <motion.div
                  layout
                  key={item.slug}
                  initial={reduce ? false : { opacity: 0.25, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={reduce ? undefined : { opacity: 0, scale: 0.97 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                >
                  <InsightCard item={item} />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
    </>
  );
}
